import { ComponentButton } from './ComponentButton';
import { HrefButton as HrefButtonType } from '@/schemas/sceneDataSchema';

export const HrefButton = ({ component }: { component: HrefButtonType }) => {
  return (
    <ComponentButton
      href={component.href}
      component={component}
      asComponent='a'
      type='button'
    />
  );
};
